import DsLink, { LinkProps } from '@carvana/ds-link';
import React from 'react';
import { useBrand } from '|/brand';
import titleCaseChildren from '|/components/carvana-ds/title-case-children';

const Link: React.FC<LinkProps> = ({ children, style, ...rest }) => {
  const { brand } = useBrand();
  // ds-link (v5) has no underline prop and standalone links aren't underlined by the
  // token, so inline style is the only reliable override. A CSS-module class loses to the
  // DS component's own hashed rules, and patching DS internals is out of bounds here.
  return (
    // eslint-disable-next-line local-rules/no-brand-in-style -- see above; no DS prop exists
    <DsLink {...rest} style={brand === 'slate' ? { textDecoration: 'underline', ...style } : style}>
      {brand === 'slate' ? titleCaseChildren(children) : children}
    </DsLink>
  );
};

export default Link;
export type { LinkProps };
